var map = {
	"./big-bummer.svg": "315a",
	"./buy-insurance.svg": "7786",
	"./little-bummer.svg": "18ef",
	"./round-1.svg": "5192",
	"./round-2.svg": "7262",
	"./round-3.svg": "c253",
	"./round-4.svg": "0812",
	"./select-add-ons.svg": "c743",
	"./survival-bonus.svg": "a315",
	"./trivia.svg": "17bf"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5a96";